let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5GUMQ")).then(() => parcelRequire('5F2lh'));